import ErrorLabel from "./ErrorLabel";

export default ErrorLabel;
